import LocationsListButtons from './LocationsListButtons';

export default LocationsListButtons;
